module.exports = __webpack_public_path__ + "static/media/Collector_img.1a26a6a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Collector/img/Collector_img.jpg
// module id = 50
// module chunks = 0